import { createAction, createAsyncAction } from 'typesafe-actions'
import {
  ReadTradableInstrumentsRequestDto,
  ReadTradableInstrumentsResponseDto,
  WsEventPayloadMap,
  WsEventType,
} from '@sparling/financial-common'

export const {
  request: getTradableInstrumentsRequest,
  success: getTradableInstrumentsSuccess,
  failure: getTradableInstrumentsFailure,
} = createAsyncAction(
  'GET_TRADABLE_INSTRUMENTS_REQUEST',
  'GET_TRADABLE_INSTRUMENTS_SUCCESS',
  'GET_TRADABLE_INSTRUMENTS_FAILURE',
)<ReadTradableInstrumentsRequestDto, ReadTradableInstrumentsResponseDto, Error>()

export const currentInstrument = createAction('CURRENT_INSTRUMENT')<string | null>()
export const instrumentPriceUpdate =
  createAction('INSTRUMENT_PRICE_UPDATE')<WsEventPayloadMap[WsEventType.INSTRUMENT_PRICE_UPDATE]>()
